/* eslint-disable @trello/no-module-logic */
import type { TypedPartialWithID } from '../../types';
import type { CheckItem, Checklist } from '../../generated';
import { GeneralizedFilterPatcher } from './generalizedFilterPatcher';
import type { ChecklistCheckItemsPatcherQuery } from './ChecklistCheckItemsPatcherQuery.generated';
import { ChecklistCheckItemsPatcherDocument } from './ChecklistCheckItemsPatcherQuery.generated';

export const checklistCheckItemsPatcher = new GeneralizedFilterPatcher<
  TypedPartialWithID<CheckItem, 'CheckItem'>,
  Checklist,
  // @ts-expect-error checkItems is unique because its camel case
  ChecklistCheckItemsPatcherQuery,
  string
>({
  parentTypeName: 'Checklist',
  modelTypeName: 'CheckItem',
  filters: {
    default: {
      dataKey: 'checkItems',
      canSyncWithEmptyData: true,
      addSingleRelationWhen: () => true,
      removeSingleRelationWhen: () => false,
      // not used
      addMultiRelationWhen: () => true,
      removeMultiRelationWhen: () => false,
    },
    all: {
      dataKey: 'checkItemsAll',
      canSyncWithEmptyData: true,
      addSingleRelationWhen: () => true,
      removeSingleRelationWhen: () => false,
      // not used
      addMultiRelationWhen: () => true,
      removeMultiRelationWhen: () => false,
    },
    due: {
      dataKey: 'checkItemsDue',
      canSyncWithEmptyData: true,
      addSingleRelationWhen: (checkItem) => !!checkItem.due,
      removeSingleRelationWhen: (checkItem) => !checkItem.due,
      // not used
      addMultiRelationWhen: () => false,
      removeMultiRelationWhen: () => false,
    },
  },
  query: ChecklistCheckItemsPatcherDocument,
});
